import React, {Component} from 'react';
import '../css/printers-card.css';
import HorizontalRuleWithContent from './horizontal-rule-with-content';
import MaterialUsageChart from '../components/material-usage-chart';
import {StatisticsOfPrinter} from './printers-card';
import LoadingAnimation from "./loading-animation";

class MaterialsCard extends Component {
    render() {
        let { materialUsageByResinName, totalNumberOfPrints, totalUsageOfResin } = this.props;
        return <div className='printers-card-container'>


            <HorizontalRuleWithContent hidden={true} content={'Material Usage on All Printers'}/>
            {materialUsageByResinName ?
                <MaterialUsageChart materialUsageByResinName={materialUsageByResinName}/>
                : <LoadingAnimation/>}
            <HorizontalRuleWithContent/>
            <StatisticsOfPrinter
                totalNumberOfPrints={totalNumberOfPrints}
                totalUsageOfResin={totalUsageOfResin}
                printsLabel={"Print Jobs Completed"}
                usageLabel={"Total Material Used"}
            />
        </div>
    }
}

export default MaterialsCard;


// WEBPACK FOOTER //
// ./src/components/material-card.js